export enum NewFederationStep {
	Create,
	Infos,
	Validation,
}
